var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "flex-column my-0 mx-n16",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', _vm._b({
    attrs: {
      "flat": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', [_c('join-video')], 1), _c('v-card-actions', [_c('v-row', {
    staticClass: "ma-n8"
  }, [_c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": ""
    }
  }, [_c('v-btn', {
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleAudio
    }
  }, [_vm.enabled_audio ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-microphone-off ")]), _c('span', [_vm._v(" 마이크 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-microphone ")]), _c('span', [_vm._v(" 마이크 켜기 ")])]], 2)], 1), _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": ""
    }
  }, [_c('v-btn', {
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleMuted
    }
  }, [_vm.enabled_muted ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-volume-high ")]), _c('span', [_vm._v(" 음소거 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-volume-off ")]), _c('span', [_vm._v(" 음소거 켜기 ")])]], 2)], 1), _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": ""
    }
  }, [_c('v-btn', {
    staticClass: "border",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.toggleVideo
    }
  }, [_vm.enabled_video ? [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-camera-off ")]), _c('span', [_vm._v(" 화면 끄기 ")])] : [_c('v-icon', {
    staticClass: "mr-8"
  }, [_vm._v(" mdi-camera ")]), _c('span', [_vm._v(" 화면 켜기 ")])]], 2)], 1), _c('v-col', {
    staticClass: "pa-8",
    attrs: {
      "cols": "6",
      "sm": "4",
      "lg": ""
    }
  }, [_c('join-exec', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var icon = _ref.icon,
          button = _ref.button,
          message = _ref.message,
          disabled = _ref.disabled;
        return [_c('v-btn', _vm._b({
          attrs: {
            "block": "",
            "color": "primary"
          },
          on: {
            "click": _vm.join
          }
        }, 'v-btn', {
          loading: _vm.loading,
          disabled
        }, false), [_c('v-icon', {
          staticClass: "mr-8"
        }, [_vm._v(" " + _vm._s(icon) + " ")]), _c('span', {
          class: {
            'grey--text text--lighten-1': disabled
          }
        }, [_vm._v(" " + _vm._s(button) + " ")])], 1), _c('p', {
          staticClass: "mt-8 font-size-14 grey--text text--lighten-2 text-center"
        }, [_c('span', [_vm._v(" " + _vm._s(message) + " ")])])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }